// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2efza","header":"ClearentDisclaimer_header__QaO78","inner":"ClearentDisclaimer_inner__P8cy0"};